<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="$route.params.id ? actions : []"
    :form="form"
    :title=" type === 'index' ? $t('menu.addTickets') : $t('model.ticketKind')"
    resource="ticket_kinds"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/ticket_kinds.js';
import { DAY_OF_WEEK_OPTIONS } from '@/constants';
import _ from 'lodash';

@Component
export default class TicketKinds extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'ticket_event_id_eq',
      'title_cont',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'ticket_event',
      'title',
      'capacity',
      type === 'show' && 'sold_capacity',
      'price_cents',
      'description',
      type === 'show' && 'activity_time_kind',
      type === 'show' && {
        key: 'start_day_of_week',
        renderCell: (h, { props: { value } }) => {
          if (value !== null) {
            return <span>{ DAY_OF_WEEK_OPTIONS[value] }</span>;
          }
        }
      },
      type === 'show' && {
        key: 'end_day_of_week',
        renderCell: (h, { props: { value } }) => {
          if (value !== null) {
            return <span>{ DAY_OF_WEEK_OPTIONS[value] }</span>;
          }
        }
      },
      type === 'show' && 'start_date',
      type === 'show' && 'end_date',
      type === 'show' && 'expiration_kind',
      // type === 'show' && 'expire_at',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type, change }) {
    const array = [
      {
        key: 'ticket_event_id',
        renderCell: {
          hint: this.$t('hint.cannotChangeAfterCreate'),
          props: {
            disabled: type === 'edit',
          }
        }
      },
      'title',
      'capacity',
      'price_cents',
      'description',
      {
        key: 'activity_time_kind',
        renderCell: {
          domProps: { style: "width: 250px;" },
          on: {
            change: (val) => {
              if (val !== data.activity_time_kind) {
                change({ start_day_of_week: null, end_day_of_week: null, start_date: null, end_date: null })
              }
            }
          }
        }
      },
      data.activity_time_kind === 'day_of_week' && {
        key: 'start_day_of_week',
        renderCell: {
          component: 'select',
          required: true,
          props: {
            options: _.map(DAY_OF_WEEK_OPTIONS, (label, value) => ({ label: label, value: Number(value) }))
          },
        }
      },
      data.activity_time_kind === 'day_of_week' && {
        key: 'end_day_of_week',
        renderCell: {
          component: 'select',
          required: true,
          props: {
            options: _.map(DAY_OF_WEEK_OPTIONS, (label, value) => ({ label: label, value: Number(value) }))
          },
        }
      },
      data.activity_time_kind === 'exact_date' && {
        key: 'start_date',
        renderCell: {
          required: true,
        }
      },
      data.activity_time_kind === 'exact_date' && {
        key: 'end_date',
        renderCell: {
          required: true,
        }
      },
      // {
      //   key: 'expiration_kind',
      //   renderCell: {
      //     domProps: { style: "width: 250px;" },
      //     on: {
      //       change: (val) => {
      //         if (val !== data.expiration_kind) {
      //           change({ expire_at: null })
      //         }
      //       }
      //     }
      //   }
      // },
      // data.expiration_kind === 'custom' && 'expire_at',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'ticket_kinds.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'ticket_kinds.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/ticket_kinds',
    name: 'ticket_kinds.index',
    component: TicketKinds,
    props: {
      type: 'index',
    }
  },
  {
    path: '/ticket_kinds/new',
    name: 'ticket_kinds.new',
    component: TicketKinds,
    props: {
      type: 'new',
    }
  },
  {
    path: '/ticket_kinds/:id',
    name: 'ticket_kinds.show',
    component: TicketKinds,
    props: {
      type: 'show',
    }
  },
  {
    path: '/ticket_kinds/:id/edit',
    name: 'ticket_kinds.edit',
    component: TicketKinds,
    props: {
      type: 'edit'
    }
  }
]
</script>
